import { DriverAssignmentMode } from './driver-assignment-mode.model';
import { ProofOfDeliveryRule } from './pod-rule.model';
import { PhotoPodRule } from './photo-pod.rule';
import { InheritableOnOffFeature, OnOffFeature } from './on-off-feature.model';
import { OrderType } from './order-type.model';
import { AutoGroupCollections } from './auto-group-collections.model';
import { CmaLiteDeliveryRule } from './cma-lite-delivery-rule.model';
import { SapDocumentTypeUploadToBy } from './sap-document-type-upload-to-by.model';

export type Option = { value: any } & ({ label: string } | { labelKey: string });

export class FeatureUtils {
  static DRIVER_ASSIGNMENT_MODE: Option[] = [
    { value: DriverAssignmentMode.CMAWEB_AND_CMA, labelKey: 'feature-profiles.features.driver-assignment-mode.options.cmaweb-and-cma' },
    { value: DriverAssignmentMode.CMAWEB, labelKey: 'feature-profiles.features.driver-assignment-mode.options.cmaweb' },
    { value: DriverAssignmentMode.TMS_ONLY, labelKey: 'feature-profiles.features.driver-assignment-mode.options.tms' }
  ];

  static PROOF_OF_DELIVERY_RULES: Option[] = [
    { value: ProofOfDeliveryRule.BOTH, labelKey: 'feature-profiles.features.proof-of-delivery-rule.options.both' },
    { value: ProofOfDeliveryRule.SIGNATURES, labelKey: 'feature-profiles.features.proof-of-delivery-rule.options.signatures' },
    { value: ProofOfDeliveryRule.PHOTO, labelKey: 'feature-profiles.features.proof-of-delivery-rule.options.photo' }
  ];

  static PHOTO_POD_RULES: Option[] = [
    { value: PhotoPodRule.ONLY_AT_THE_DROP_LOCATION, labelKey: 'feature-profiles.features.photo-proof-of-delivery-rule.options.drop' },
    { value: PhotoPodRule.PICK_LOCATION_FOR_COLLECTION, labelKey: 'feature-profiles.features.photo-proof-of-delivery-rule.options.pick' }
  ];

  static INHERITABLE_ON_OFF_POSSIBLE_VALUES: Option[] = [
    { value: InheritableOnOffFeature.ON, labelKey: 'feature-profiles.features.on-off.options.on' },
    { value: InheritableOnOffFeature.OFF, labelKey: 'feature-profiles.features.on-off.options.off' }
  ];

  static ON_OFF_POSSIBLE_VALUES: Option[] = [
    { value: OnOffFeature.ON, labelKey: 'feature-profiles.features.on-off.options.on' },
    { value: OnOffFeature.OFF, labelKey: 'feature-profiles.features.on-off.options.off' }
  ];

  static AUTO_GROUP_COLLECTION: Option[] = [
    { value: AutoGroupCollections.YES, labelKey: 'feature-profiles.features.sap-multicollection-checkin.options.yes' },
    { value: AutoGroupCollections.NO, labelKey: 'feature-profiles.features.sap-multicollection-checkin.options.no' }
  ];

  static USE_CMA_LITE_OVER_CICO_DELIVERY_RULE: Option[] = [
    { value: CmaLiteDeliveryRule.Z2, labelKey: 'feature-profiles.features.use-cma-lite-over-cico-delivery-rule.options.z2' },
    { value: CmaLiteDeliveryRule.Z2_INTERNATIONALS_ONLY, labelKey: 'feature-profiles.features.use-cma-lite-over-cico-delivery-rule.options.z2-internationals-only' },
  ];

  static AUTOMATIC_TRIP_CREATION_ORDER_TYPES: Option[] = [
    { value: OrderType.RETURN, labelKey: 'feature-profiles.features.automatic-trip-creation.order-types.returns' },
    { value: OrderType.ISSUE, labelKey: 'feature-profiles.features.automatic-trip-creation.order-types.issues' },
    { value: OrderType.STO, labelKey: 'feature-profiles.features.automatic-trip-creation.order-types.sto' },
    { value: OrderType.MANAGED_RECOVERY, labelKey: 'feature-profiles.features.automatic-trip-creation.order-types.managed-recoveries' },
  ]

  static SAP_DOCUMENT_TYPE_UPLOAD_TO_BLUEYONDER: Option[] = [
    { value: SapDocumentTypeUploadToBy.PROOF_OF_DELIVERY_IMAGE, labelKey: 'regions.form.sap-document-type-upload-to-by.options.proof-of-delivery-image' },
    { value: SapDocumentTypeUploadToBy.BILL_OF_LADING, labelKey: 'regions.form.sap-document-type-upload-to-by.options.bill-of-lading' },
  ]
}
